import isEmail from 'validator/lib/isEmail';

export const isValidEmail = (text: string) => {
  return isEmail(text);
};

export const isValidPassword = (text: string) => {
  return text.length >= 6;
};
